import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TWTabNav } from '../../../components/ui';

const TABS = [
  { id: 'devices', label: 'Devices', path: '/dashboard/devices' },
  { id: 'releases', label: 'Releases', path: '/dashboard/devices/releases' },
  { id: 'rollouts', label: 'Rollouts', path: '/dashboard/devices/rollouts' },
  { id: 'enroll', label: 'Enrollment', path: '/dashboard/devices/enroll' },
];

// The area's tab strip. It navigates; each tab is its own route.
const DevicesNav = ({ current }) => {
  const navigate = useNavigate();
  return (
    <TWTabNav
      ariaLabel="Devices sections"
      tabs={TABS.map(({ id, label }) => ({ id, label }))}
      value={current}
      onChange={(id) => {
        const tab = TABS.find((t) => t.id === id);
        if (tab && id !== current) navigate(tab.path);
      }}
    />
  );
};

export default DevicesNav;
